import { useContext, useState } from "react";
import TabBox, { Tab } from "../../Components/Tabbox/TabBox";
import Accounts from "./Accounts/Accounts";
import Aggregate from "./Aggregate";
import Details from "./Details/Details";
import PortfoPairPosition from "./PortfoPairPosition/PortfoPairPosition";
import RolePairPosition from "./RolePairPosition/RolePairPosition";
import ServerTabBox from "src/Components/Tabbox/ServerTabBox";
import { useSearchParams } from "react-router-dom";
import { ServerTabsContext } from "src/Layout/MasterPage";

enum ActiveTab {
  Accounts = "Accounts",
  Aggregate = "CumulativeCalculations",
  Details = "PartialCalculations",
  PortfoPairPosition = "PairCalculationsPortfo",
  RolePairPosition = "PairCalculationsRoll",
}

const DeltaHedgeAccounts = () => {
  const [searchParams] = useSearchParams({
    activeTab: ActiveTab.Accounts,
  });
  const tabs = useContext(ServerTabsContext).deltaHedgeAccounts;
  const activeTab = searchParams.get("activeTab") || "#";

  const getUI = () => {
    switch (activeTab) {
      case ActiveTab.Accounts:
        return <Accounts />;

      case ActiveTab.Aggregate:
        return <Aggregate />;

      case ActiveTab.Details:
        return <Details />;

      case ActiveTab.PortfoPairPosition:
        return <PortfoPairPosition />;

      case ActiveTab.RolePairPosition:
        return <RolePairPosition />;

      default:
        <></>;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-8 px-5 mx-auto relative mt-10">
      <div className="w-min">
        <ServerTabBox children={tabs?.tabs} />
      </div>
      {getUI()}
    </div>
  );
};

export default DeltaHedgeAccounts;
